import { render, staticRenderFns } from "./TextBase.vue?vue&type=template&id=15a4f880&scoped=true&"
import script from "./TextBase.vue?vue&type=script&lang=ts&"
export * from "./TextBase.vue?vue&type=script&lang=ts&"
import style0 from "./TextBase.vue?vue&type=style&index=0&id=15a4f880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a4f880",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15a4f880')) {
      api.createRecord('15a4f880', component.options)
    } else {
      api.reload('15a4f880', component.options)
    }
    module.hot.accept("./TextBase.vue?vue&type=template&id=15a4f880&scoped=true&", function () {
      api.rerender('15a4f880', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/text/TextBase.vue"
export default component.exports